import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogActions, TextField } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import PropTypes from "prop-types";
import TextareaAutosize from "@mui/base/TextareaAutosize";
import styled from "@emotion/styled";

const StyledTextarea = styled(TextareaAutosize)(({ theme }) => ({
  width: "100%",
  minHeight: "50px",
  padding: "8px 12px",
  borderRadius: "8px",
  border: "1px solid black",
  fontFamily: "inherit",
  fontSize: "14px",
  resize: "vertical",
  "&:focus": {
    outline: "none",
    borderWidth: "2px",
  },
  "&::placeholder": {
    color: "rgba(0, 0, 0, 0.42)",
  },
}));

export default function Description({
  isOpen,
  handleClose,
  handleSave,
  isLoading,
  currentDescription,
  startDate,
}) {
  const [description, setDescription] = useState(currentDescription);

  useEffect(() => {
    setDescription(currentDescription);
  }, [currentDescription]);

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  const onSave = () => {
    handleSave(description);
  };

  return (
    <Dialog
      sx={{
        "& .MuiDialog-paper": {
          width: "450px",
          maxWidth: "90%",
          borderRadius: "10px",
        },
        "& .MuiDialogContent-root": {
          padding: "32px 26px 16px 26px",
        },
        "& .MuiDialogActions-root": {
          padding: "16px 24px 24px 24px",
        },
      }}
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="description-dialog-title"
    >
      <DialogContent>
        <SoftBox mb={0.5}>
          <SoftTypography variant="h6" fontWeight="medium" textAlign="start">
            Leaderboard Info
          </SoftTypography>
        </SoftBox>
        <SoftBox mb={2}>
          <SoftTypography
            variant="caption"
            color="secondary"
            fontWeight="medium"
            textAlign="start"
            display="block"
          >
            This competition started on {startDate}
          </SoftTypography>
        </SoftBox>
        <SoftBox mb={1}>
          <SoftTypography variant="button" fontWeight="medium">
            Description
          </SoftTypography>
        </SoftBox>
        <StyledTextarea value={description} onChange={handleDescriptionChange} />
      </DialogContent>
      <DialogActions>
        <SoftBox display="flex" gap={2} width="100%" justifyContent="center">
          <SoftButton variant="gradient" color="dark" onClick={handleClose} disabled={isLoading}>
            Cancel
          </SoftButton>
          <SoftButton variant="gradient" color="info" onClick={onSave} disabled={isLoading}>
            {isLoading ? "Saving..." : "Save"}
          </SoftButton>
        </SoftBox>
      </DialogActions>
    </Dialog>
  );
}

Description.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  currentDescription: PropTypes.string,
  startDate: PropTypes.string,
};
